import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Flame, ArrowRight } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password minima 6 caratteri");
      return;
    }
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Account creato. Pronto ad allenarti!");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore di registrazione");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0F] flex">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-2 mb-8">
            <Flame className="w-6 h-6 text-[#FF3B30]" strokeWidth={2.5} />
            <span className="font-display font-black text-2xl uppercase">Fit<span className="text-[#FF3B30]">Command</span></span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0AB] mb-3">Nuovo Atleta</div>
          <h1 className="font-display text-5xl font-black uppercase leading-none tracking-tight mb-8">
            Iniziamo<span className="text-[#FF3B30]">.</span>
          </h1>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="text-xs font-bold tracking-[0.2em] uppercase text-[#A0A0AB] mb-2 block">Nome</label>
              <input
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                data-testid="register-name"
                className="w-full bg-[#141419] border border-[#2A2A35] px-4 py-3 focus:border-[#FF3B30] focus:outline-none"
                placeholder="Il tuo nome"
              />
            </div>
            <div>
              <label className="text-xs font-bold tracking-[0.2em] uppercase text-[#A0A0AB] mb-2 block">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="register-email"
                className="w-full bg-[#141419] border border-[#2A2A35] px-4 py-3 focus:border-[#FF3B30] focus:outline-none"
                placeholder="tua@email.it"
              />
            </div>
            <div>
              <label className="text-xs font-bold tracking-[0.2em] uppercase text-[#A0A0AB] mb-2 block">Password</label>
              <input
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="register-password"
                className="w-full bg-[#141419] border border-[#2A2A35] px-4 py-3 focus:border-[#FF3B30] focus:outline-none"
                placeholder="Min 6 caratteri"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="register-submit"
              className="w-full bg-[#FF3B30] text-white font-bold uppercase tracking-widest py-4 hover:bg-[#e02e24] transition-all flex items-center justify-center gap-2 disabled:opacity-50"
            >
              {loading ? "Creazione..." : "Crea account"} <ArrowRight className="w-4 h-4" />
            </button>
          </form>
          <div className="mt-6 text-sm text-[#A0A0AB]">
            Hai già un account?{" "}
            <Link to="/login" data-testid="link-login" className="text-white hover:text-[#FF3B30] font-bold uppercase tracking-widest text-xs">
              Accedi →
            </Link>
          </div>
        </div>
      </div>
      <div className="hidden lg:flex flex-1 relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1603297430336-03c3265b54f9?crop=entropy&cs=srgb&fm=jpg&w=940"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-bl from-[#0B0B0F] via-[#0B0B0F]/60 to-transparent" />
      </div>
    </div>
  );
}
